<div class="not-authorized bg-primary">
  <div class="text-wrapper text-center">
    <h1 class="text-white">403 Not Authorized</h1>
    <button mat-raised-button color="accent" (click)="logout()">
      Log Out
    </button>
  </div>
</div>